import { NumberInput } from '@framework/form';
import React from 'react';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import {
  IRepeatControllerWidget,
  RepeatControllerComponentType,
} from './IRepeatControllerWidget';

export interface IRepeatControllerWidgetPreviewProps
  extends IWidgetComponentProps<IRepeatControllerWidget> {}

export function RepeatControllerWidgetPreview(
  props: IRepeatControllerWidgetPreviewProps,
) {
  const { widget } = props;
  const options = getWidgetProps(props);
  if (widget.kind === RepeatControllerComponentType.Input)
    return (
      <ConfigFormItem
        name={options.name}
        label={<RichTextAdvancedRender inline text={options.label} />}
        help={<RichTextAdvancedRender inline text={options.helpText} />}
        layout={{ hideVisualLabel: options.hideLabel }}
        readonly={options.readonly}
      >
        <NumberInput
          name={options.name}
          placeholder={options.placeholder}
          value={options.value as any}
          tabIndex={-1}
        />
      </ConfigFormItem>
    );

  return <div>Computed</div>;
}
